import { render } from "./browse-pager.vue?vue&type=template&id=0f270ad0&scoped=true&ts=true"
import script from "./browse-pager.vue?vue&type=script&setup=true&lang=ts"
export * from "./browse-pager.vue?vue&type=script&setup=true&lang=ts"

import "./browse-pager.vue?vue&type=style&index=0&id=0f270ad0&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f270ad0"],['__file',"src/components/browse-pager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f270ad0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f270ad0', __exports__)) {
    console.log('reload')
    api.reload('0f270ad0', __exports__)
  }
  
  module.hot.accept("./browse-pager.vue?vue&type=template&id=0f270ad0&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0f270ad0', render)
  })

}


export default __exports__